import CrmJourneys from "@/pages/CrmJourneys";

export default function CRMJourneysTab() {
  return <CrmJourneys />;
}